import { EXTERNAL_URLS } from '../../constants/urls';
import { devPortalAxiosClient } from '../client/DevPortalAxiosClient';

export const logout = async (): Promise<void> => {
  await devPortalAxiosClient.post(EXTERNAL_URLS.DEVELOPER_PORTAL_LOGOUT);
};
